import { Component } from '@angular/core';
import { LandingPageService } from '../landing-page/landing-page.service';
import { Router } from '@angular/router';
import { SharingDataService } from 'src/sharing-data.service';

@Component({
  selector: 'app-bestsellers',
  templateUrl: './bestsellers.component.html',
  styleUrls: ['./bestsellers.component.css']
})
export class BestsellersComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }

  
  ngOnInit(): void {
    // Your initialization logic here
    console.log('Component initialized!');
    this.viewAllMaleProducts();
    this. viewProductComponent=false;
    this.Cart=0;
  }

    constructor(private landingPageService : LandingPageService,private router: Router,private sharingData: SharingDataService){}
    Cart=0;
    products:any;
    maleProducts:any;
  malePlain: any[] = [];
    viewProductComponent=false;

 addToCart(tshirt:any){
  this.Cart=this.Cart+1;
  console.log("Cart=",this.Cart);
  console.log("tshirt=",tshirt.name);
 }

 viewAllFourProducts(){
  this.landingPageService.ViewAllProductsFunctions().subscribe({
    next:(response) => {
      console.log('All products are', response);
      this.products=response;
      console.log('All products are', this.products);
    },
    error: (err) => {
      console.error('Error:', err);
    }
  });
}

viewProduct(product:Object) {
  console.log(" menOversizedPlain button clicked");
  this.viewProductComponent = true;
  this.router.navigate(['/viewProducts']);
  this.sharingData.updateValue(product);
  console.log('clicked view product: ',product);
}

viewAllMaleProducts(){
  // const targetImages=[
  //   '../../assets/img/IMG_man_beige_plain_1.jpg',
  //   '../../assets/img/IMG_pista_eye_man_4.jpg',
  //   '../../assets/img/IMG_man_black_plain_2.jpg',
  //   '../../assets/img/IMG_man_pista_plain_4.jpg'
  // ]
  this.sharingData.GetAllMaleProducts().subscribe({
    next:(response) => {
     
      this.maleProducts=response;
      console.log('all producrs',response)
      this.malePlain = [];
       for(let i=0;i<this.maleProducts.length;i++){
       if ((this.maleProducts[i].category) == 'Plain'){
         console.log('Category is Plain');
          this.malePlain.push(this.maleProducts[i]);
  //           this.malePlain = [
  //   { src: '../../assets/img/IMG_man_beige_plain_1.jpg', name: 'Black T Rs699' , label: 'Add to Cart'},
  //   { src: '../../assets/img/IMG_pista_eye_man_4.jpg', name: 'Red T Rs699' , label: 'Add to Cart' },
  //   { src: '../../assets/img/IMG_man_black_plain_2.jpg', name: 'White T Rs699' , label: 'Add to Cart' },
  //   { src: '../../assets/img/IMG_man_black_plain_2.jpg', name: 'Blue T Rs699' , label: 'Add to Cart' }
   
  // ];
        }
      }
      console.log('All man plain  are', this.malePlain);
    },
    error: (err) => {
      console.error('Error:', err);
    }
  });
}
}

